import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-58ac8886")

_pushScopeId("data-v-58ac8886")
const _hoisted_1 = { class: "app-dnd-list" }
const _hoisted_2 = { class: "list-group-item" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" No Data ")
_popScopeId()

import { ref } from 'vue'
import draggable from 'vuedraggable'


export default _defineComponent({
  props: {
  itemKey: {
    type: String,
    required: true,
  },
  group: {
    type: String,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
  textColor: {
    type: String,
    required: true,
  },
},
  emits: ["onChange"] as unknown as undefined,
  setup(__props, { emit: $emits }: { emit: ((e: 'onChange', value: unknown) => void), expose: any, slots: any, attrs: any }) {

const props = __props




const expanded = ref(true)

function onChange(_$event) {
  $emits('onChange', props.items)
}

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!

  return (_openBlock(), _createBlock(_component_q_expansion_item, {
    dense: "",
    "dense-toggle": "",
    "switch-toggle-side": "",
    modelValue: expanded.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (expanded.value = $event)),
    class: "cus-expansion q-mt-md",
    "expand-icon-class": 'text-'+ __props.textColor + ' q-pr-none'
  }, {
    header: _withId(() => [
      (_ctx.$slots)
        ? _renderSlot(_ctx.$slots, "title", { key: 0 })
        : _createCommentVNode("", true)
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_unref(draggable), {
          class: "list-group",
          list: __props.items,
          group: __props.group,
          itemKey: __props.itemKey,
          onChange: onChange
        }, _createSlots({
          item: _withId(({ element, index }) => [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_q_item, {
                class: "cursor-move q-pr-none",
                key: index
              }, {
                default: _withId(() => [
                  _createVNode(_component_q_item_section, {
                    avatar: "",
                    style: {"min-width":"30px","width":"30px"}
                  }, {
                    default: _withId(() => [
                      _renderSlot(_ctx.$slots, "item-icon", {}, () => [
                        _createVNode(_component_q_icon, {
                          name: "drag_indicator",
                          color: "grey",
                          size: "sm"
                        })
                      ])
                    ]),
                    _: 3
                  }),
                  _createVNode(_component_q_item_section, { side: "" }, {
                    default: _withId(() => [
                      _renderSlot(_ctx.$slots, "item-content", { item: element })
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          _: 2
        }, [
          (_ctx.$slots.empty)
            ? {
                name: "header",
                fn: _withId(() => [
                  (!__props.items.length)
                    ? _renderSlot(_ctx.$slots, "empty", { key: 0 }, () => [
                        _hoisted_3
                      ])
                    : _createCommentVNode("", true)
                ])
              }
            : undefined
        ]), 1032, ["list", "group", "itemKey"])
      ])
    ]),
    _: 3
  }, 8, ["modelValue", "expand-icon-class"]))
}
}

})